import { Row, Col, List, ListItem } from 'twyne-new.ui';

import Actions from './Actions';
import Header from './Header';
import OAuthIcon from './Icon';

export default function GoogleOAuth({ credential, user, details, onChange }) {
  return <List className='p-0' >
    <ListItem selected={credential} className='twy-border-base border px-4'>
      <Row className='items-center justify-center w-full'>
        <Col size="9" className=''>
          <Row className='gap-0'>
            <Col size="auto">
              <OAuthIcon
                credential={credential}
              />
            </Col>
            <Col className='px-0 mt-1'>
              <Header
                user={user}
                details={details}
              />
            </Col>
          </Row>
        </Col>
        <Col size="3" className='flex items-center justify-end'>
          <Actions
            connected={!!credential}
            onChange={onChange}
          />
        </Col>
      </Row>
    </ListItem>
  </List>
}
